<template>
  <el-row class="m-0 width-100-p height-100-p">
 <el-col
  :class="[
    'd-flex',
    'align-items-center',
    $vuetify.display.width < 700 ? 'px-0 mt-20' :
    $vuetify.display.width < 1500 ? 'px-2 mt-20' : 'px-2'
  ]"
  :span="$vuetify.display.width >= 1500 ? 24 : $vuetify.display.width >= 700 ? 8 : 24"
>
  <div class="row m-0 py-3 width-100-p height-100-p bg-me-primary border-color-light rounded-4 d-flex align-items-center">
    <div class="d-flex justify-content-between align-items-center width-100-p px-2">
      <div class="flex-grow-1 ml-30">
        <p class="font-25-b text-white mb-0">
          {{ dashboardData.number_of_sites.value.toLocaleString() }}
        </p>
        <p class="font-14 mt-2 text-white mb-0">
          {{ dashboardData.number_of_sites.title }}
        </p>
      </div>
          <div v-if="$vuetify.display.width <= 700 || $vuetify.display.width >= 1500" class="width-80 height-80 mr-20 ml-3 flex-shrink-0">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#ev-distance"></use>
            </svg>
          </div>
          <div v-if="$vuetify.display.width > 700 && $vuetify.display.width < 1500" class="width-60 height-60 ml-20 mr-20 ml-3 flex-shrink-0">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#ev-distance-60"></use>
            </svg>
          </div>
    </div>
  </div>
</el-col>

<el-col
  :class="[
    'd-flex',
    'align-items-center',
    'mt-20',
    $vuetify.display.width < 700 ? 'px-0' :
    $vuetify.display.width < 1500 ? 'px-2' : 'px-2'
  ]"
  :span="$vuetify.display.width >= 1500 ? 24 : $vuetify.display.width >= 700 ? 8 : 24"
>
  <div class="row m-0 py-3 width-100-p height-100-p bg-me-primary border-color-light rounded-4 d-flex align-items-center">
    <div class="d-flex justify-content-between align-items-center width-100-p px-2">
      <div class="flex-grow-1 ml-30">
        <p class="font-25-b text-white mb-0">
          {{ dashboardData.number_of_chargers_onsite.value.toLocaleString() }}
          <!-- DEBUG: {{ dashboardData.number_of_chargers_onsite.value }} -->
        </p>
        <p class="font-14 mt-2 text-white mb-0">
          {{ dashboardData.number_of_chargers_onsite.title }}
        </p>
      </div>
          <div v-if="$vuetify.display.width <= 700 || $vuetify.display.width >= 1500" class="width-80 height-80 mr-20 ml-3 flex-shrink-0">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#num-chargers"></use>
            </svg>
          </div>
          <div v-if="$vuetify.display.width > 700 && $vuetify.display.width < 1500" class="width-60 height-60 ml-20 mr-20 ml-3 flex-shrink-0">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#num-charging-site-60"></use>
            </svg>
          </div>
    </div>
  </div>
</el-col>

<el-col
  :class="[
    'd-flex',
    'align-items-center',
    'mt-20',
    $vuetify.display.width < 700 ? 'px-0' :
    $vuetify.display.width < 1500 ? 'px-2' : 'px-2'
  ]"
  :span="$vuetify.display.width >= 1500 ? 24 : $vuetify.display.width >= 700 ? 8 : 24"
>
  <div class="row m-0 py-3 width-100-p height-100-p bg-me-primary border-color-light rounded-4 d-flex align-items-center">
    <div class="d-flex justify-content-between align-items-center width-100-p px-2">
      <div class="flex-grow-1 ml-30">
        <p class="font-25-b text-white mb-0">
          {{ dashboardData.number_of_ports.value.toLocaleString() }}
        </p>
        <p class="font-14 mt-2 text-white mb-0">
          {{ dashboardData.number_of_ports.title }}
        </p>
      </div>
          <div v-if="$vuetify.display.width <= 700 || $vuetify.display.width >= 1500" class="width-80 height-80 mr-20 ml-3 flex-shrink-0">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#num-ports"></use>
            </svg>
          </div>
          <div v-if="$vuetify.display.width > 700 && $vuetify.display.width <1500" class="width-60 height-60 ml-20 mr-20 ml-3 flex-shrink-0">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#num-ports-60"></use>
            </svg>
          </div>
    </div>
  </div>
</el-col>
 </el-row>
</template>

<script>
export default {
  props: {
    dataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      dashboardData: {
        number_of_sites: { title: "Number of sites", value: 0 },
        number_of_chargers_onsite: { title: "Number of chargers with onsite renewable", value: 0 },
        number_of_ports: { title: "Number of ports", value: 0 },
      },
    };
  },
  computed: {
    renewableChargerCount() {
      return this.dataProp?.renewable_charger_count || 0;
    }
  },
  watch: {
    dataProp: {
      handler: function (newValue) {
        console.log('=== chargerCard dataProp watcher ===');
        console.log('newValue.renewable_charger_count:', newValue.renewable_charger_count);

        this.dashboardData.number_of_sites.value = newValue.site_count;
        this.dashboardData.number_of_chargers_onsite.value = newValue.renewable_charger_count || 0;
        this.dashboardData.number_of_ports.value = newValue.port_count;

        console.log('After assignment - dashboardData.number_of_chargers_onsite.value:', this.dashboardData.number_of_chargers_onsite.value);
        console.log('Full dashboardData object:', this.dashboardData);
      },
      deep: true,
    },
  },
  methods: {},
};
</script>
